<template>
    <v-menu offset-y :content-class="'notifications-menu--theme'" :nudge-left="18" :nudge-bottom="15">
        <template v-slot:activator="{ on }">
            <div class="notification-button-container" v-on="on" v-tippy content="Notifications" :class="{'--active': notificationsOfActiveOrganization.length > 0}">
                <i class="material-icons notifications-button">notifications</i>
                <Counter :notifications="notifications.length" />
            </div>
        </template>
        <div class="notifications-menu-content">
            <span v-if="notifications.length == 0" class="empty-notifications-message">There are no new notifications</span>

            <div class="notifications-wrapper">
                <div v-for="notification in notifications"
                     :key="notification.id"
                     class="notification"
                     :class="{'--from-guest': isNotificationFromGuest(notification)}"
                >
                    <template v-if="notificationType(notification) == 'newFileCreated'">
                        <div class="thumbnail-container">
                            <img class="project-image" :src="projectsFeaturedImage(notification.data.project_id)" alt=""
                                 v-tippy="{ placement: 'top', boundary: 'window' }"
                                 :content="notification.data.project_name"
                            />
                            <i class="material-icons">image</i>
                        </div>
                        <div class="notification-title"
                             @click="onSelection(notification)"
                        >
                            {{ notification.data.file_ids.length }} New
                            {{ notification.data.file_ids.length > 1 ? 'files have' : 'file has' }} been uploaded to a bin
                            <span class="font-weight-bold color-primary">{{ notification.data.bin_name }}</span> in
                            project <span
                            class="font-weight-bold color-primary"
                        >{{ notification.data.project_name }}</span>.
                            <span class="notification-created-at">
                                {{ createdAt(notification) }}
                            </span>
                        </div>
                    </template>


                    <template v-else-if="notificationType(notification) == 'newCommentCreated'">
                        <div class="thumbnail-container">
                            <img class="avatar" :src="avatar(notification)" alt=""
                                 v-tippy="{ placement: 'top', boundary: 'window' }"
                                 :content="name(notification)"
                            />
                            <i class="material-icons">message</i>
                        </div>
                        <div class="notification-title" @click="onSelection(notification)">
                            There is a new comment from user
                            <span class="font-weight-bold color-primary">{{ name(notification) }}</span>
                            in the {{ notification.data.channel == 'shared' ? 'shared' : ''}} comments thread
                            <template v-if="notification.data.file_name">
                                of file
                                <span class="font-weight-bold color-primary">{{ stripTimestampAndExtension(notification.data.file_name) }}</span>
                            </template>
                            of bin
                            <span class="font-weight-bold color-primary">{{ notification.data.bin_name }}</span>
                            in project
                            <span class="font-weight-bold color-primary">{{ notification.data.project_name }}</span>.
                            <span class="notification-created-at">
                                {{ createdAt(notification) }}
                            </span>
                        </div>
                    </template>

                    <template v-else-if="notificationType(notification) == 'newCommentWithMentionCreated'">
                        <div class="thumbnail-container">
                            <img class="avatar" :src="avatar(notification)" alt=""
                                 v-tippy="{ placement: 'top', boundary: 'window' }"
                                 :content="name(notification)"
                            />
                            <i class="material-icons">person</i>
                        </div>
                        <div class="notification-title" @click="onSelection(notification)">
                            You were mentioned by user
                            <span class="font-weight-bold color-primary">{{ name(notification) }}</span>
                            in the {{ notification.data.channel == 'shared' ? 'shared' : ''}} comments thread
                            <template v-if="notification.data.file_name">
                                of file
                                <span class="font-weight-bold color-primary">{{ stripTimestampAndExtension(notification.data.file_name) }}</span>
                            </template>
                            of bin
                            <span class="font-weight-bold color-primary">{{ notification.data.bin_name }}</span> in
                            project
                            <span class="font-weight-bold color-primary">{{ notification.data.project_name }}</span>.
                            <span class="notification-created-at">
                                {{ createdAt(notification) }}
                            </span>
                        </div>
                    </template>

<!--                    <span class="notification-read-status" :class="{'&#45;&#45;unread': !notification.read_at}"></span>-->

                    <v-menu :content-class="'notification-options-container'" offset-y>
                        <template v-slot:activator="{ on, attrs }">
                            <i class="material-icons notification-options-btn" v-bind="attrs" v-on="on">
                                more_vert
                            </i>
                        </template>
                        <v-list>
                            <v-list-item @click="markAsRead(notification)">
                                <span class="option">Mark as read</span>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>
            </div>

            <div class="bottom-buttons-container" v-if="notifications.length > 0">
                <button type="button" class="modal-btn" :disabled="notifications.length == 0" @click="markAllAsRead">
                    <span>Mark all as read</span>
                </button>
            </div>

        </div>
    </v-menu>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import AvatarMixins from "@/mixins/Avatar";
import Counter from "./Counter";
import FilenameMixin from "@/mixins/Filename";

export default {
    name: "NotificationsMenu",
    mixins: [AvatarMixins, FilenameMixin],
    components: {
        Counter,
    },

    computed: {
        ...mapState("Notifications", {
            activeNotification: 'active'
        }),
        ...mapGetters('Notifications', {
            notifications: 'notificationsOfActiveOrganization'
        }),
        ...mapGetters('Projects', ['userOfProject', 'projectsFeaturedImage']),
        ...mapGetters('Notifications', ['notificationsOfActiveOrganization']),
        ...mapGetters("User", ["isGuest"]),
    },

    methods: {
        avatar(notification) {
            return this.getGravatar(this.userOfProject(notification.data.created_by, notification.data.project_id)?.email);
        },
        name(notification) {
            return this.userOfProject(notification.data.created_by, notification.data.project_id)?.name;
        },
        isNotificationFromGuest(notification) {
            if (this.isGuest) return false;
            if (this.$store.state.Organizations.users.find(user => user.user.id == notification.data.created_by)){
                let user = this.$store.state.Organizations.users.find(user => user.user.id == notification.data.created_by);
                if (user.role_id == 7) return true;
            }
        },
        createdAt(notification) {
            let createdAt = Moment(notification.created_at).fromNow();
            if (createdAt == 'just now ago') {
                createdAt = createdAt.split(' ago')[0];
            }
            return createdAt;
        },
        markAllAsRead() {
            this.$store.dispatch('Notifications/markAllAsRead');
        },

        markAsRead(notifications) {
            this.$store.dispatch('Notifications/markAsRead', [notifications]);
        },

        notificationType(notification) {
            if (notification.type == "App\\Notifications\\NewFileCreated") return 'newFileCreated';
            else {
                if (notification.data.is_mention) return 'newCommentWithMentionCreated';
                else return 'newCommentCreated';
            }
        },

        async onSelection(notification) {
            if (!this.$store.state.Projects.projects.find(project => project.id == notification.data.project_id)) return;

            this.$store.dispatch('Notifications/setActive', notification);

            if (!this.$store.state.Projects.project.id) {
                await this.$store.dispatch('Notifications/markAsRead', [this.activeNotification]);
                this.$store.dispatch("Projects/setModalSelectedProject", this.activeNotification.data.project_id);
                await this.$root.projectsModal.openProject();
                this.$store.dispatch('Notifications/followNotification');
            } else if (this.$store.state.Projects.project.id == notification.data.project_id) {
                await this.$store.dispatch('Notifications/markAsRead', [this.activeNotification]);
                this.$store.dispatch('Notifications/followNotification');
            } else {
                window.UI.showModal($('#confirm-project-switch-modal'));
            }

            this.$store.dispatch("Projects/refreshProjectTree", false);
        }
    }
}
</script>

<style lang="scss" scoped>
.empty-notifications-message {
    color: #ababab;
    text-align: center;
    margin: 20px 0 0;
}

.notification.--from-guest {
    background: rgba(217, 80, 64, 0.1);
}

.notification-button-container {
    cursor: pointer;
    position: relative;
    display: flex;
    align-items: center;

    .notifications-button {
        font-size: 20px;
    }

    &.--active {
        .notifications-button {
            color: var(--primary);
        }
    }
}

.notification-options-container {
    border-radius: var(--box-rounding);

    .v-list {
        background: var(--dark-gray);
        padding: 25px 0;

        .v-list-item {
            min-height: 20px;
            padding: 0 25px;
            cursor: pointer;

            &:hover {
                background: #363636;
            }

            &--disabled {
                opacity: 0.6;
            }

            .option {
                color: var(--font-default-color);
                font-size: 1rem;
            }
        }
    }
}

.thumbnail-container {
    margin-right: 15px;
    position: relative;
    align-self: flex-start;

    .avatar {
        max-width: initial;
        width: 40px;
        height: 40px;
    }

    .project-image {
        max-width: initial;
        width: 40px;
        height: 40px;
        //max-width: 40px;
        border-radius: 25px;
        object-fit: cover;
        border: 1px solid var(--primary);
    }

    i {
        position: absolute;
        bottom: 0px;
        right: -6px;
        background: var(--primary);
        font-size: 14px;
        color: var(--dark-gray);
        border-radius: 50px;
        padding: 3px;
    }
}

.notifications-menu--theme {
    contain: initial;
    overflow: visible;

    &::before {
        position: absolute;
        content: "";
        top: 0;
        left: 20px;
        transform: translateY(-100%);
        width: 10px;
        height: 13px;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-bottom: 13px solid var(--dark-gray);
    }

    .notifications-menu-content {
        background: var(--dark-gray);
        padding: 25px 0;
        border-radius: var(--box-rounding);
        width: 400px;
        display: flex;
        flex-direction: column;


        .notifications-wrapper {
            max-height: 500px;
            margin-bottom: 25px;
            overflow-y: scroll;
            scrollbar-color: #989898 transparent;
            scrollbar-width: thin;
            &::-webkit-scrollbar {
                width: 5px;
            }
            &::-webkit-scrollbar-thumb {
                background-color: #989898;
                border-radius: 50px;
            }
        }

        .notification {
            display: grid;
            grid-template-columns: auto 1fr auto;
            grid-template-areas: 'thumbnail content menu';
            //justify-content: stretch;
            min-height: 24px;
            padding: 12px 25px 0 25px;
            font-size: 12px;
            color: #989898 !important;
            font-size: 12px !important;
            cursor: pointer;
            position: relative;

            .notification-title {
                line-height: 1.25;
                grid-area: content;
            }

            .notification-created-at {
                margin-top: 10px;
                font-size: 10px;
                border-bottom: 1px solid #363636;
                padding-bottom: 12px;
                display: block;
            }

            &:hover {
                background: #363636;
                &:before {
                    position: absolute;
                    left: 0;
                    top: -1px;
                    height: 1px;
                    width: 100%;
                    background: #363636;
                    content: '';
                    display: block;
                }
            }

            > a {
                display: block;
                line-height: 2;
                width: 100%;
            }

            &.navigation-link {
                color: #989898 !important;
            }

            //.notification-read-status {
            //    width: 8px;
            //    height: 8px;
            //    background: transparent;
            //    border-radius: 50px;
            //    align-self: center;
            //    margin: 0 10px 0 15px;
            //    &.--unread {
            //        background: var(--primary);
            //    }
            //}

            .notification-options-btn {
                //display: none;
                visibility: hidden;
                //position: absolute;
                //right: 10px;
                //top: 50%;
                //transform: translateY(-50%);
                font-size: 18px;
                align-self: center;
            }

            &:hover .notification-options-btn {
                //display: block;
                visibility: visible;
            }
        }

        a {
            color: #989898;
            text-decoration: none;

            &:hover {
                color: #b9b9b9;
                transition: color 0.5s ease;
            }
        }
    }
}

.bottom-buttons-container {
    margin-top: auto;
    display: flex;
    justify-content: center;
}

button {
    background: transparent;
    border: 1px solid var(--font-default-color);
    color: var(--font-default-color);

    &:hover {
        color: white;
        border-color: white;

        span {
            color: white;
        }
    }

    > span {
        color: var(--font-default-color);
    }

    &[disabled]:hover {
        border: 1px solid var(--font-default-color);
        color: var(--font-default-color);

        span {
            color: var(--font-default-color);
        }
    }
}

</style>